import { render, staticRenderFns } from "./CreateFab.vue?vue&type=template&id=2a55b440&scoped=true"
import script from "./CreateFab.vue?vue&type=script&lang=js"
export * from "./CreateFab.vue?vue&type=script&lang=js"
import style0 from "./CreateFab.vue?vue&type=style&index=0&id=2a55b440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55b440",
  null
  
)

export default component.exports